import iconFile from '../../assets/images/icon_url.gif';
import TopBase, { type TopBaseProps } from '../lib/TopBase';

class UrlTop extends TopBase {
    constructor(props: TopBaseProps) {
        super(props);
        this.type = 'url';
        this.label = 'Url';
        this.icon = iconFile;
        this.description = '[en]Related web pages.[/en][ja]関連Webページ[/ja]';
    }
}

export default UrlTop;
